import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

// redux
import {
  setLoading,
  setLoadingMessage,
  setTicketList,
} from "../../../../redux/actions";

//api
import { getTickets } from "../../../../utils/api/restClient";

// components
import { LoadingComponent } from "../../../../components/layout/loading/LoadingComponent";
import TicketListCarusell from "../../../../components/ticket/ticketListCarusell";

function TicketsPage() {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.Layout.loading);

  useEffect(() => {
    window.scrollTo(0, 0);

    const getTicketsFromApi = async () => {
      try {
        dispatch(
          dispatch(
            setLoadingMessage(
              "Hämtar biljett status.",
              "Getting ticket status."
            )
          )
        );
        const res = await getTickets();
        if (res !== undefined && res.tickets.length > 0) {
          dispatch(setTicketList(res.tickets));
        } else {
          dispatch(setTicketList(null));
        }
        dispatch(setLoading(false));
      } catch (error) {
        console.error("Error fetching ticket:", error);
        dispatch(setLoading(false));
        dispatch(setTicketList(null));
      }
    };

    getTicketsFromApi();
  }, [dispatch]);

  if (loading) {
    return <LoadingComponent></LoadingComponent>;
  }
  return (
    <div className="container min-height-100 mt-5">
      <div className="row pt-4">
        <div className="col-12 col-centered">
          <TicketListCarusell />
        </div>
      </div>
    </div>
  );
}

export default TicketsPage;
